export default __webpack_public_path__ + "static/media/circle-xmark.bfb26ace.svg";